import React from "react";
import { motion } from "framer-motion";
import { MapPin, Mail, Phone } from "lucide-react";

const items = [
  {
    icon: MapPin,
    title: "Head Office",
    lines: [
      "FLAT,504, NAV-HRISHIKESH, CO OP SOC LTD BLDG NO 15, MIRA ROAD,",
      "THANE, THANE- 401107, MAHARASHTRA",
    ],
  },
  {
    icon: Mail,
    title: "Email Us",
    lines: ["mdsttravels@gmail.com"],
  },
  {
    icon: Phone,
    title: "Call Us",
    lines: ["7900189196"],
  },
];

const Footer = () => {
  return (
    <footer
      className="max-w-[1280px] mx-auto px-5 lg:px-10 pb-10"
      data-testid="site-footer"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="rounded-2xl border border-slate-200 bg-white shadow-[0_10px_40px_-20px_rgba(15,27,45,0.15)] px-6 sm:px-10 py-7"
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-slate-200">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                className="flex items-start gap-4 md:px-6 first:md:pl-0 last:md:pr-0 pt-6 md:pt-0 first:pt-0"
                data-testid={`footer-item-${idx}`}
              >
                <div className="shrink-0 w-11 h-11 rounded-full bg-blue-50 text-[#2563EB] flex items-center justify-center">
                  <Icon size={20} strokeWidth={2} />
                </div>
                <div className="leading-snug">
                  <div className="font-bold text-[#0F1B2D] mb-1">
                    {it.title}
                  </div>
                  {it.lines.map((l) => (
                    <div
                      key={l}
                      className="text-[14px] text-slate-600 break-words"
                    >
                      {l}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </motion.div>

      <div className="text-center text-xs text-slate-400 mt-6">
        © {new Date().getFullYear()} MDST Travels. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
